import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header/Header';
import BlogCards from '../components/BlogCards';


const Updates = () => {
    return (
        <>
            <Header />
            <BlogCards/>
            <Footer />
        </>
    )
}

export default Updates;